import { render, staticRenderFns } from "./SpinningDice.vue?vue&type=template&id=3abab393&scoped=true"
import script from "./SpinningDice.vue?vue&type=script&lang=js"
export * from "./SpinningDice.vue?vue&type=script&lang=js"
import style0 from "./SpinningDice.vue?vue&type=style&index=0&id=3abab393&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abab393",
  null
  
)

export default component.exports